import { Validators } from "@angular/forms";

export interface CashInFields {
  name: string;            
  label: string;           
  validators: any[];       
}

export const CASHIN_COUNTRY_FIELDS: Record<string, CashInFields[]> = {
  CLP: [
    { name: 'customerName',   label: 'common.fullName',        validators: [Validators.required] },
    { name: 'customerEmail',  label: 'common.email',           validators: [Validators.required, Validators.email] },
    { name: 'documentNumber', label: 'common.documentNumber',  validators: [] },
    { name: 'documentType',   label: 'common.documentTypeCLP', validators: [] },
  ],

  COP: [
    { name: 'customerName',   label: 'common.fullName',        validators: [Validators.required] },
    { name: 'customerPhone',  label: 'common.phoneTenDigits',  validators: [] },
    { name: 'customerEmail',  label: 'common.email',           validators: [Validators.required, Validators.email] },
    { name: 'documentNumber', label: 'common.documentNumber',  validators: [] },
    { name: 'documentType',   label: 'common.documentTypeCOP', validators: [] },
    { name: 'bankCode',       label: 'common.bankCodeEx',      validators: [] },
    { name: 'accountNo',      label: 'common.accountNo',       validators: [] },
  ],

  PEN: [
    { name: 'customerName',   label: 'common.fullName',        validators: [Validators.required] },
    { name: 'customerPhone',  label: 'common.phoneNineDigits', validators: [] },
    { name: 'customerEmail',  label: 'common.email',           validators: [Validators.required, Validators.email] },
    { name: 'documentNumber', label: 'common.documentNumber',  validators: [] },
    { name: 'documentType',   label: 'common.documentTypePEN', validators: [] },
  ]
};
